

<div class="tvHeader">
    <div class="logoName">
        flowtrics
    </div>
    <div class="facName">
        Green Cares
    </div>
    <div class="dateTime">
        Tuesday, Jan 12 <span class="time" >11:00 AM</span>
    </div>
</div>
<div class="listHolder">
    <table class="table" >
        <tr>
            <th>Pat Arrival</th>
            <th>Sch Start</th>
            <th>Rooms</th>
            <th>Pat</th>
            <th>Surgeon</th>
            <th>Procedure</th>

            <th>Tags</th>
            <th>Anthesia</th>
            <th>Anes</th>
            <th>Description</th>
            <th>Status</th>
            <th>Updated</th>
        </tr>
        <tr>
            <td>6:00 AM</td>
            <td>7:00 AM</td>
            <td>F1-1</td>
            <td>N/A</td>
            <td>M. Mcalpin</td>
            <td>Debridement of wound, burn, or infection</td>

            <td>
                <div class="tagHolder">
                    <span class="t1" >TU</span>
                    <span class="t2">MK</span>
                </div>
            </td>
            <td>N/A</td>
            <td>Lim</td>
            <td>Signed document Needed</td>
            <td>Scheduled</td>
            <td>8:08 AM</td>
        </tr>
        <tr>
            <td>6:00 AM</td>
            <td>7:00 AM</td>
            <td>F1-1</td>
            <td>N/A</td>
            <td>M. Mcalpin</td>
            <td>Inguinal hernia repair</td>

            <td>
            <div class="tagHolder">
                <span class="t1" >TU</span>
                <span class="t2">MK</span>
            </div>
            </td>
            <td>N/A</td>
            <td>Lim</td>
            <td>Patient Relative required</td>
            <td>In Room</td>
            <td>8:08 AM</td>
        </tr>
        <tr>
            <td>6:00 AM</td>
            <td>7:00 AM</td>
            <td>F1-1</td>
            <td>N/A</td>
            <td>M. Mcalpin</td>
            <td>Debridement of wound, burn, or infection</td>

            <td>
                <div class="tagHolder">
                    <span class="t1" >TU</span>
                    <span class="t2">MK</span>
                </div>
            </td>
            <td>N/A</td>
            <td>Lim</td>
            <td>Signed document Needed</td>
            <td>Scheduled</td>
            <td>8:08 AM</td>
        </tr>
        <tr>
            <td>6:00 AM</td>
            <td>7:00 AM</td>
            <td>F1-1</td>
            <td>N/A</td>
            <td>M. Mcalpin</td>
            <td>Inguinal hernia repair</td>

            <td>
            <div class="tagHolder">
                <span class="t1" >TU</span>
                <span class="t2">MK</span>
            </div>
            </td>
            <td>N/A</td>
            <td>Lim</td>
            <td>Patient Relative required</td>
            <td>In Room</td>
            <td>8:08 AM</td>
        </tr>
        <tr>
            <td>6:00 AM</td>
            <td>7:00 AM</td>
            <td>F1-1</td>
            <td>N/A</td>
            <td>M. Mcalpin</td>
            <td>Debridement of wound, burn, or infection</td>

            <td>
                <div class="tagHolder">
                    <span class="t1" >TU</span>
                    <span class="t2">MK</span>
                </div>
            </td>
            <td>N/A</td>
            <td>Lim</td>
            <td>Signed document Needed</td>
            <td>Scheduled</td>
            <td>8:08 AM</td>
        </tr>
        <tr>
            <td>6:00 AM</td>
            <td>7:00 AM</td>
            <td>F1-1</td>
            <td>N/A</td>
            <td>M. Mcalpin</td>
            <td>Inguinal hernia repair</td>

            <td>
            <div class="tagHolder">
                <span class="t1" >TU</span>
                <span class="t2">MK</span>
            </div>
            </td>
            <td>N/A</td>
            <td>Lim</td>
            <td>Patient Relative required</td>
            <td>In Room</td>
            <td>8:08 AM</td>
        </tr>
    </table>
</div>